import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"20px","text-align":"right"} }
const _hoisted_2 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }

import { unref, ref, onMounted, reactive } from 'vue';
import { useRouter } from 'vue-router';

/* NPM Plugins */
import { ElButton } from 'element-plus';
import moment from 'moment';

/* Components */
import { CategoryDialog, ValidDialog } from './components/Index';
import { CategoryParentTreeList } from '@/components/lists/Index';
import { GbTables } from '@/components/GbTables';

/* Hooks */
import { useGbTable } from '../../hooks/useGbTable';
// 添加多语言支持
import { useLocales } from '@/hooks/useLocales';

/* API */
import { GetCategoryListApi, CategoryDelApi } from '../../apis/ct_categorys/category.api';

/* Types */
import { CategorySearch } from '../../apis/ct_categorys/category.dto';
import { TableColumn } from '../../components/GbTables/GbTablesTypes';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useLocales();

const writerRef = ref<ComponentRef<typeof CategoryDialog>>();
const validRef = ref<ComponentRef<typeof ValidDialog>>();

const { register, tableObject, methods } = useGbTable<any>({
	getListApi: GetCategoryListApi,
	delListApi: CategoryDelApi,
	response: { data: 'data', total: 'total' },
});

const { setSearchParams } = methods;

const search = reactive<CategorySearch>({
	current: 1,
	page_size: 10,
});

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
	{ field: 'code', label: t('categorys.table.categoryCode', '分类编号'), columnWidth: '120' },
	{ field: 'name', label: t('categorys.table.categoryName', '分类名称'), columnWidth: '280' },
	{ field: 'remark', label: t('categorys.table.remark', '备注') },
	// { field: 'level', label: '当前层级', columnWidth: "80", align: 'center' },
	{ field: 'is_enabled', label: t('status.status', '状态'), columnWidth: '80', align: 'center' },
	{ field: 'created_time', label: t('draft.createdTime', '创建时间'), columnWidth: '120', align: 'center' },
	{ field: 'action', width: '120px', label: t('contractList.table.action', '操作'), fixed: 'right', align: 'center' },
]);

/* 内部事件 */
const actions = {
	/* 创建分类 */
	create: () => {
		unref(writerRef)?.create(search.parent_id || '');
	},

	createParent: () => {
		unref(writerRef)?.create('10000000-0000-0000-0000-000000000001');
	},

	/* 修改某个分类 */
	modify: (data: any) => {
		unref(writerRef)?.modify(data.id);
	},

	valid: (row: any) => {
		unref(validRef)?.showDialog(row.id, row.name);
	},

	/* 删除 */
	delete: (row: any) => {
		const delData = { id: row.id, revision: row.revision };
		methods.deleteRows(delData);
	},
};
const onTreeNodeChange = (perId: any) => {
	search.parent_id = perId;
	setSearchParams(search);
};

onMounted(() => {
	setSearchParams(search);
});

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_More = _resolveComponent("More")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, { gutter: 10 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_unref(CategoryParentTreeList), { onNodeChange: onTreeNodeChange })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, {
              shadow: "never",
              "body-style": { paddingBottom: '0' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  size: "small",
                  inline: true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      "label-width": '80px',
                      label: _unref(t)('categorys.table.categoryCode', '分类编号')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(search).code,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(search).code) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      "label-width": '80px',
                      label: _unref(t)('categorys.table.categoryName', '分类名称')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(search).name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(search).name) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElButton), {
                          type: "primary",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('buttons.search', '查询')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, {
              shadow: "never",
              style: {"margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_unref(ElButton), {
                    size: "small",
                    type: "primary",
                    onClick: actions.createParent
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('categorys.buttons.addMajorCategory', '新增大类')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_unref(ElButton), {
                    size: "small",
                    type: "primary",
                    onClick: actions.create
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('categorys.buttons.addCategory', '新增分类')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createVNode(_unref(GbTables), {
                  pageSize: _unref(tableObject).pageSize,
                  "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
                  currentPage: _unref(tableObject).currentPage,
                  "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
                  columns: _unref(tabColumns),
                  data: _unref(tableObject).tableList,
                  loading: _unref(tableObject).loading,
                  pagination: { total: _unref(tableObject).total },
                  onRegister: _unref(register)
                }, {
                  created_time: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY/MM/DD HH:mm')), 1)
                  ]),
                  is_enabled: _withCtx(({ row }) => [
                    (row.is_enabled == 'Y')
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          type: "success",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('status.enabled', '启用')), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_tag, {
                          key: 1,
                          type: "warning",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('status.diabled', '停用')), 1)
                          ]),
                          _: 1
                        }))
                  ]),
                  action: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_unref(ElButton), {
                        type: "info",
                        link: "",
                        onClick: ($event: any) => (actions.modify(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('buttons.modify', '编辑')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_dropdown, {
                        style: {"padding":"2px","margin-left":"12px"},
                        trigger: "click"
                      }, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_dropdown_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ElButton), {
                                    type: "info",
                                    link: "",
                                    onClick: ($event: any) => (actions.valid(row))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('categorys.buttons.validateConfig', '验证配置')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_dropdown_item, { divided: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ElButton), {
                                    type: "danger",
                                    link: "",
                                    onClick: ($event: any) => (actions.delete(row))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('buttons.delete', '删除')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_More)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 1
                }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(CategoryDialog), {
      ref_key: "writerRef",
      ref: writerRef
    }, null, 512),
    _createVNode(_unref(ValidDialog), {
      ref_key: "validRef",
      ref: validRef
    }, null, 512)
  ], 64))
}
}

})